var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "registry-paper registry-profile" }, [
    _c(
      "header",
      { staticClass: "p-4 border-bottom" },
      [
        _vm.editing
          ? _c("RegistryFieldEditor", {
              key: `license:${_vm.license.id}:details`,
              ref: "editor",
              attrs: {
                record: _vm.license,
                kind: "license",
                "can-update": _vm.canUpdate,
                metadata: _vm.metadata,
              },
              on: {
                saved: _vm.saved,
                cancel: _vm.cancelEdit,
                reload: function ($event) {
                  return _vm.$emit("reload")
                },
              },
            })
          : [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-start",
                },
                [
                  _c("div", [
                    _c("h2", { staticClass: "h3 mb-1" }, [
                      _vm._v(_vm._s(_vm.recordName(_vm.license))),
                    ]),
                    _vm.value("legal_name") &&
                    _vm.value("legal_name") !== _vm.recordName(_vm.license)
                      ? _c("div", { staticClass: "text-muted" }, [
                          _vm._v(
                            "Legal name: " +
                              _vm._s(_vm.text(_vm.value("legal_name")))
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.canUpdate && _vm.detailTab === "overview"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-primary ml-3",
                          attrs: { type: "button" },
                          on: { click: _vm.edit },
                        },
                        [_vm._v("Edit")]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "registry-license-number mt-3" }, [
                _vm._v(
                  _vm._s(_vm.text(_vm.license.identity.display_number)) + " "
                ),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v("· " + _vm._s(_vm.license.identity.issuing_state)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c("b-badge", { attrs: { variant: _vm.standingColor } }, [
                    _vm._v(_vm._s(_vm.standingLabel)),
                  ]),
                  _c("span", { staticClass: "text-muted ml-2" }, [
                    _vm._v("· " + _vm._s(_vm.expiration)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.standingNotes
                ? _c("div", { staticClass: "small mt-1" }, [
                    _vm._v(_vm._s(_vm.standingNotes)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.openConflicts.length
                ? _c("div", { staticClass: "small text-danger mt-1" }, [
                    _vm._v(
                      "Identity conflict. New active-only use is blocked."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.incomingConflicts.length
                ? _c("div", { staticClass: "small text-warning mt-1" }, [
                    _vm._v(
                      _vm._s(_vm.incomingConflicts.length) +
                        " Disputed License Claim(s) name this identity."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.license.local_inactivation
                ? _c("div", { staticClass: "small mt-1" }, [
                    _vm._v(
                      "Inactivated by admin " +
                        _vm._s(_vm.date(_vm.license.local_inactivation.at)) +
                        ": " +
                        _vm._s(_vm.license.local_inactivation.reason)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.replacement.replaced_by
                ? _c("div", { staticClass: "small mt-2" }, [
                    _vm._v("Replaced by "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit(
                              "open-license",
                              _vm.replacement.replaced_by.id
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.identity(_vm.replacement.replaced_by))
                        ),
                      ]
                    ),
                    _vm._v(
                      ". Existing commercial references stay on this record."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.replacement.replacement_of || [], function (original) {
                return _c(
                  "div",
                  { key: original.id, staticClass: "small mt-1" },
                  [
                    _vm._v("Replacement of "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("open-license", original.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.identity(original)))]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "dl",
                { staticClass: "registry-facts mt-3 mb-0" },
                _vm._l(
                  ["license_type", "designation", "business_types"],
                  function (field) {
                    return _c("div", { key: field }, [
                      _c("dt", [_vm._v(_vm._s(_vm.label(field)))]),
                      _c("dd", [_vm._v(_vm._s(_vm.text(_vm.value(field))))]),
                    ])
                  }
                ),
                0
              ),
              _vm._v(" "),
              _vm.canUpdate
                ? _c("div", { staticClass: "d-flex flex-wrap mt-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-secondary mr-2 mb-1",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", {
                              kind: _vm.license.local_inactivation
                                ? "reactivate"
                                : "inactivate",
                              license: _vm.license,
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.license.local_inactivation
                              ? "Reactivate"
                              : "Inactivate"
                          )
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary mb-1",
                        attrs: {
                          type: "button",
                          disabled: !!_vm.replacement.replaced_by,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", {
                              kind: "replace",
                              license: _vm.license,
                            })
                          },
                        },
                      },
                      [_vm._v("Create replacement")]
                    ),
                  ])
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "nav",
      {
        staticClass: "nav nav-tabs px-3 pt-2",
        attrs: { "aria-label": "License details" },
      },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "button",
          {
            key: tab.key,
            staticClass: "nav-link",
            class: { active: _vm.detailTab === tab.key },
            attrs: {
              type: "button",
              "aria-current": _vm.detailTab === tab.key ? "page" : null,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("tab", tab.key)
              },
            },
          },
          [_vm._v(_vm._s(tab.label))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "p-4" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.detailTab === "overview",
              expression: "detailTab === 'overview'",
            },
          ],
        },
        [
          _c(
            "section",
            [
              _c("div", { staticClass: "registry-section-heading" }, [
                _c("h3", [
                  _vm._v("Locations "),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.locations.length)),
                  ]),
                ]),
                _vm.canUpdate
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", {
                              kind: "license-links",
                              license: _vm.license,
                              role: "location",
                            })
                          },
                        },
                      },
                      [_vm._v("Manage links")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "small",
                  class:
                    _vm.completeLocationCount === _vm.locations.length &&
                    _vm.completeLocationCount
                      ? "text-muted"
                      : "registry-address-summary-warning",
                },
                [_vm._v(_vm._s(_vm.addressSummary))]
              ),
              _vm._v(" "),
              _vm._l(_vm.locations, function (link, index) {
                return _c(
                  "div",
                  {
                    key: link.resolved
                      ? _vm.typedKey(link.resolved)
                      : `unresolved:${index}`,
                    staticClass: "registry-location border rounded p-3 mb-2",
                  },
                  [
                    link.resolved
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-link p-0 font-weight-bold text-left",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("open-entity", link.resolved)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.text(link.resolved.name, "Unnamed location")
                              )
                            ),
                          ]
                        )
                      : _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.text(
                                link.evidence &&
                                  (link.evidence.common_name ||
                                    link.evidence.legal_name),
                                "Location not linked"
                              )
                            )
                          ),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "small mt-1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.address(
                            link.resolved && link.resolved.effective_address
                              ? link.resolved.effective_address.values
                              : _vm.locationEvidence(link)
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    !link.resolved
                      ? _c("small", { staticClass: "text-warning" }, [
                          _vm._v(
                            _vm._s(
                              link.resolution === "suppressed"
                                ? "Source relationship suppressed."
                                : "No resolved location record."
                            ) + " Reported address is evidence only."
                          ),
                        ])
                      : _vm.missingAddress(link).length
                      ? _c("small", { staticClass: "text-warning" }, [
                          _vm._v(
                            "Missing " +
                              _vm._s(
                                _vm
                                  .missingAddress(link)
                                  .map(_vm.label)
                                  .join(", ")
                              ) +
                              " for order placement."
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.scopeTarget("location", link.resolved)
                      ? _c("RegistryContacts", {
                          attrs: {
                            "license-id": _vm.license.id,
                            group: "location",
                            target: _vm.scopeTarget("location", link.resolved),
                            "refresh-key": _vm.refreshKey,
                          },
                          on: {
                            "open-entity": function ($event) {
                              return _vm.$emit("open-entity", $event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.locations.length
                ? _c("p", { staticClass: "small text-muted" }, [
                    _vm._v("No locations reported."),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.scopeErrors.location
                ? _c(
                    "div",
                    {
                      staticClass: "small text-danger",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(_vm._s(_vm.scopeErrors.location) + " "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-link",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.loadScope("location")
                            },
                          },
                        },
                        [_vm._v("Retry")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "mt-4" },
            [
              _c("div", { staticClass: "registry-section-heading" }, [
                _c("h3", [_vm._v("Reported companies")]),
                _vm.canUpdate
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", {
                              kind: "license-links",
                              license: _vm.license,
                              role: "hq",
                            })
                          },
                        },
                      },
                      [_vm._v("Manage links")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "small text-muted" }, [
                _vm._v(
                  "Reported connections and titles do not establish ownership or authority."
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.companies, function (company) {
                return _c(
                  "div",
                  { key: company.key, staticClass: "border-bottom py-2" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-link p-0 font-weight-bold text-left",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("open-entity", company.entity)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.text(company.entity.name, "Unnamed company")
                              )
                            ),
                          ]
                        ),
                        _c("small", { staticClass: "text-muted ml-2" }, [
                          _vm._v(_vm._s(company.roles.join(", "))),
                        ]),
                      ]
                    ),
                    company.target
                      ? _c("RegistryContacts", {
                          attrs: {
                            "license-id": _vm.license.id,
                            group: "corporate",
                            target: company.target,
                            "refresh-key": _vm.refreshKey,
                          },
                          on: {
                            "open-entity": function ($event) {
                              return _vm.$emit("open-entity", $event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.companies.length && !_vm.scopeLoading.corporate
                ? _c("p", { staticClass: "small text-muted" }, [
                    _vm._v("No linked companies reported."),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.scopeErrors.corporate
                ? _c(
                    "div",
                    {
                      staticClass: "small text-danger",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(_vm._s(_vm.scopeErrors.corporate) + " "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-link",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.loadScope("corporate")
                            },
                          },
                        },
                        [_vm._v("Retry")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.scopeLoading.location || _vm.scopeLoading.corporate
            ? _c(
                "p",
                {
                  staticClass: "small text-muted mt-3",
                  attrs: { role: "status" },
                },
                [_vm._v("Loading contact counts and relationship paths…")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(["location", "corporate"], function (group) {
            return _c(
              "section",
              { key: group, staticClass: "mt-3" },
              _vm._l(_vm.unresolved(group), function (path, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "small text-warning mb-2" },
                  [
                    _vm._v(
                      _vm._s(_vm.role(path.role)) +
                        ": " +
                        _vm._s(
                          path.resolution === "suppressed"
                            ? "source relationship suppressed"
                            : "association unresolved"
                        ) +
                        ". Contacts through this path are unavailable."
                    ),
                    (path.candidates || []).length
                      ? _c(
                          "span",
                          [
                            _vm._v(" Possible records: "),
                            _vm._l(path.candidates, function (candidate) {
                              return _c(
                                "button",
                                {
                                  key: _vm.typedKey(candidate),
                                  staticClass: "btn btn-sm btn-link",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("open-entity", {
                                        ...candidate,
                                        possible: true,
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.text(
                                        candidate.name,
                                        `Unnamed ${candidate.type}`
                                      )
                                    )
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("details", [
                      _c("summary", [_vm._v("Relationship evidence")]),
                      _c("pre", [_vm._v(_vm._s(_vm.json(path)))]),
                    ]),
                  ]
                )
              }),
              0
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.detailTab !== "overview",
              expression: "detailTab !== 'overview'",
            },
          ],
        },
        [
          _vm.detailTab === "source"
            ? _c("p", { staticClass: "small" }, [
                _c("strong", [_vm._v(_vm._s(_vm.standingLabel))]),
                _vm._v(
                  " · Evaluated " +
                    _vm._s(_vm.license.standing.evaluated_for_date) +
                    ". " +
                    _vm._s(
                      (_vm.license.standing.reasons || [])
                        .map(_vm.label)
                        .join(", ")
                    )
                ),
              ])
            : _vm._e(),
          _c("RegistryEvidence", {
            attrs: {
              record: _vm.license,
              section: _vm.detailTab,
              "can-update": _vm.canUpdate,
            },
            on: {
              action: function ($event) {
                return _vm.$emit("action", $event)
              },
              "open-license": function ($event) {
                return _vm.$emit("open-license", $event)
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }